export const METRIC_ABBREVIATIONS: { [key: string]: string } = {
  accountCreated: 'AC',
  install: 'IC',
  installScheduled: 'IS',
  kilowattsInstalled: 'kWI',
  leagueScore: 'LS',
  permitSubmitted: 'PS',
  welcomeCall: 'WC',
};
